<template>
	<div class="element-image is-empty">
		<img v-if="file" :src="file" class="img-fluid" />
	</div>
</template>

<script>
	import store from '../../store'
	export default {
		props: {
            definition: { type: Object, required: true },
            element:    { type: Object, required: true },
        },
		computed: {
			file() {
				if (store.state.type == 'signed-engagement' && this.definition.options && this.definition.options.file) {
					let path = 'http://localhost/'
					let url = this.definition.options.file.split('/').slice(3).join('/')
					return path + url
				}
				return this.definition.options && this.definition.options.file ? this.definition.options.file : null
			},
		}
	}
</script>
